import { effect, Signal, signal } from '@angular/core';
import { timer } from 'rxjs';

export class PaginationService<T> {
  protected sortField = signal<keyof T | null>(null);
  protected sortDirection = signal<'asc' | 'desc'>('asc');

  // Paginación
  protected currentPage = signal<number>(1);
  protected recordsPerPage = signal<number>(10);

  // Búsqueda con debounce
  protected searchQuery = signal<string>('');
  protected debouncedSearchQuery = signal<string>('');

  constructor() {
    effect(() => {
      const query = this.searchQuery();
      timer(200).subscribe(() => this.debouncedSearchQuery.set(query));
    });
  }

  getRecordsPerPage(): Signal<number> {
    return this.recordsPerPage;
  }

  getSortField(): Signal<keyof T | null> {
    return this.sortField;
  }

  getSortDirection(): Signal<'asc' | 'desc'> {
    return this.sortDirection;
  }

  /** Cambiar la página actual */
  setCurrentPage(page: number): void {
    this.currentPage.set(page);
  }

  /** Cambiar la cantidad de registros por página */
  setRecordsPerPage(records: number): void {
    this.recordsPerPage.set(records);
    this.setCurrentPage(1);
  }
  
  public getCurrentPage(): number {
    return this.currentPage();
  }

  public getRecordsPerPage1(): number {
    return this.recordsPerPage();
  }

  /** Define el criterio de búsqueda con debounce */
  setSearchQuery(query: string): void {
    this.searchQuery.set(query);
  }

  /** Define el ordenamiento */
  setSort(field: keyof T, direction: 'asc' | 'desc'): void {
    this.sortField.set(field);
    this.sortDirection.set(direction);
  }
}
